/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./TeamTrigger.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { CoverImage } from './CoverImage';
var styles = {
  cardtriggerwrapper: "_1e0c1kw7",
  cardwrapper: "_2rko12b0 _1bsbnklw _kqswh2mm",
  cardheader: "_4t3i1qr7 _1bsb1osq",
  cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
  loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw",
  grayoutImage: "_kdam7g3v"
};
export var CardTriggerWrapper = function CardTriggerWrapper() {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.cardtriggerwrapper)
  });
};
export var CardWrapper = function CardWrapper(_ref) {
  var testId = _ref.testId,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.cardwrapper),
    backgroundColor: "elevation.surface.overlay",
    testId: testId
  }, children);
};
export var CardHeader = function CardHeader(_ref2) {
  var image = _ref2.image,
    isLoading = _ref2.isLoading,
    label = _ref2.label,
    isDisabled = _ref2.isDisabled;
  return isLoading || !image ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.cardheader, isDisabled && styles.grayoutImage),
    backgroundColor: "color.background.neutral"
  }) : /*#__PURE__*/React.createElement(CoverImage, {
    alt: label || '',
    src: image,
    isDisabled: isDisabled
  });
};
export var CardContent = function CardContent(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.cardcontent)
  }, props));
};
export var LoadingWrapper = function LoadingWrapper(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.loadingwrapper)
  }, props));
};